<template>
    <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
      <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Manage Categories</h2>
  
      <!-- Align Add Button to the Right -->
      <div class="flex justify-end mb-4">
        <button class="px-4 py-2 rounded-lg bg-green hover:bg-green hover:text-gray-200 text-gray-100" @click="openAddCategoryModal">
          Add
        </button>
      </div>
  
      <!-- Categories Table -->
      <table class="w-full text-left border-collapse">
        <thead>
          <tr>
            <th class="p-2 border-b-2">Category Name</th>
            <th class="p-2 border-b-2">Created Date</th>
            <th class="p-2 border-b-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(category, index) in categories" :key="index" class="hover:bg-gray-100">
            <td class="p-2 border-b">{{ category.name }}</td>
            <td class="p-2 border-b">{{ formatDate(category.createdAt) }}</td>
            <td class="p-2 border-b">
              <button @click="viewCategory(category)" class="text-blue-500 hover:text-blue-700 focus:outline-none px-2">
                <i class="fas fa-eye"></i>
              </button>
              <button @click="editCategory(category)" class="text-gray-500 hover:text-gray-700 focus:outline-none px-2">
                <i class="fas fa-edit"></i>
              </button>
              <button @click="deleteCategory(category)" class="text-red-500 hover:text-red-700 focus:outline-none px-2">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="categories.length === 0">
            <td colspan="5" class="text-center text-gray-500 p-4">No categories available.</td>
          </tr>
        </tbody>
      </table>
      <!-- Modals -->
      <AddCategoryModal v-if="isAddCategoryModalOpen" @closeModal="isAddCategoryModalOpen = false" />
      <ViewCategoryModal v-if="isViewCategoryModalOpen" :category="selectedCategory" @closeModal="isViewCategoryModalOpen = false" />
      <EditCategoryModal v-if="isEditCategoryModalOpen" :category="selectedCategory" @closeModal="isEditCategoryModalOpen = false" />
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  import AddCategoryModal from './AddCategoryModal.vue';
  import ViewCategoryModal from './ViewCategoryModal.vue';
  import EditCategoryModal from './EditCategoryModal.vue';
  export default {
    components: { 
      AddCategoryModal,
      ViewCategoryModal,
      EditCategoryModal
    },
    data(){
      return{
        isAddCategoryModalOpen: false,
        isViewCategoryModalOpen: false,
        isEditCategoryModalOpen: false,
        selectedCategory: null,
      }
    },
    async mounted() {
      await this.fetchCategories();
    },
    computed : {
    ...mapState('categories', {
      categories: state => state.categories,
    })
    },

    methods: {
      ...mapActions('categories', 
      { fetchCategories: 'fetchCategories' , deleteCategory : 'deleteCategory'}
    ),
    openAddCategoryModal() {
      this.isAddCategoryModalOpen = true;
    },
    viewCategory(category) {
      this.selectedCategory = category;
      console.log(this.selectedCategory);
      this.isViewCategoryModalOpen = true;
    },
    editCategory(category) {
      console.log(category)
      this.selectedCategory = category;
      this.isEditCategoryModalOpen = true;
    },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    }
  };
  </script>
  